<tlk-modal-header [id]="'lab-broker-unavailable-header'" header>
	<span class="lab-broker-unavailable__title">
		<tlk-warning-icon style="width: 32px; height: 32px;"/>
		{{ 'DentiraUnavailable.Title' | translate }}
	</span>
</tlk-modal-header>

<tlk-modal-content content>
	<p class="lab-broker-unavailable__subtitle">{{ 'DentiraUnavailable.Subtitle' | translate }}</p>
	<p class="lab-broker-unavailable__helper">{{ 'DentiraUnavailable.HelperText' | translate }}</p>

	<tlk-radio-group
		name="lab-brokerUnavailableOption"
		class="lab-broker-unavailable__options"
		[(ngModel)]="selectedOption"
	>
		<div
			class="lab-broker-unavailable__option"
			[class.lab-broker-unavailable__option_selected]="selectedOption === 'tryAgainLater'"
			data-testid="lab-broker-unavailable-option-try-again-later"
			(click)="selectTryAgainLater()"
		>
			<tlk-radio-button
				class="lab-broker-unavailable__radio"
				value="tryAgainLater"
				[checked]="selectedOption === 'tryAgainLater'"
			></tlk-radio-button>
			<span class="lab-broker-unavailable__option-icon lab-broker-unavailable__option-icon_scanner">
				<rx-save-continue-scanner-icon />
			</span>
			<div class="lab-broker-unavailable__option-text">
				<span class="lab-broker-unavailable__option-title">
					{{ 'DentiraUnavailable.TryAgainTitle' | translate }}
				</span>
				<span class="lab-broker-unavailable__option-subtext">
					{{ 'DentiraUnavailable.TryAgainSubtext' | translate }}
				</span>
			</div>
		</div>

		<div
			class="lab-broker-unavailable__option"
			[class.lab-broker-unavailable__option_selected]="selectedOption === 'completeOnLabBroker'"
			data-testid="lab-broker-unavailable-option-complete-on-lab-broker"
			(click)="selectCompleteOnLabBroker()"
		>
			<tlk-radio-button
				class="lab-broker-unavailable__radio"
				value="completeOnLabBroker"
				[checked]="selectedOption === 'completeOnLabBroker'"
			></tlk-radio-button>
			<span class="lab-broker-unavailable__option-icon lab-broker-unavailable__option-icon_lab-broker">
				<rx-save-continue-lab-broker-icon />
			</span>
			<div class="lab-broker-unavailable__option-text">
				<span class="lab-broker-unavailable__option-title">
					{{ 'DentiraUnavailable.CompleteOnDentiraTitle' | translate: { name: data.name } }}
				</span>
				<span class="lab-broker-unavailable__option-subtext">
					{{ 'DentiraUnavailable.CompleteOnDentiraSubtext' | translate: { name: data.name } }}
				</span>
			</div>
		</div>
	</tlk-radio-group>
</tlk-modal-content>

<tlk-modal-footer footer>
	<ng-container ngProjectAs="[right-buttons]">
		<button
			tlkButton
			variant="secondary"
			size="m"
			data-testid="lab-broker-unavailable-cancel"
			(click)="cancel()"
		>
			{{ 'SaveAndContinueLater.Cancel' | translate }}
		</button>
		<button
			tlkButton
			variant="primary"
			size="m"
			data-testid="lab-broker-unavailable-confirm"
			[disabled]="isConfirmDisabled"
			(click)="confirm()"
		>
			{{ 'SaveAndContinueLater.Confirm' | translate }}
		</button>
	</ng-container>
</tlk-modal-footer>
